import * as React from 'react'
import clsx from 'classnames'

import { DealerAdItemInfo } from 'Services/dealer_ad'
import { useAdStat } from 'Components/ad/index'
import { EVENTID, AD_RIT } from 'Constants/ad'
import styles from './index.module.scss'

export type SourceDataType = Omit<
  DealerAdItemInfo,
  'image_left_big' | 'image_right_big' | 'image_list'
>

type Props = {
  sourceData: SourceDataType
  className?: string
  teaParams?: {
    page_id: string
    [key: string]: string | number | undefined
  }
}

const AdTextLink: React.FC<Props> = ({ sourceData, className, teaParams }) => {
  const adTeaParams = React.useMemo(
    () => ({
      ad_rit: sourceData.rit_str,
      event_id: EVENTID[sourceData.rit_str as AD_RIT],
      ...teaParams,
    }),
    [sourceData, teaParams]
  )

  const { ref, handleClick } = useAdStat(
    {
      send: 'ad_send_event',
      show: 'ad_show_event',
      click: 'ad_clk_event',
    },
    sourceData,
    adTeaParams
  )
  const handleTextClick = () => {
    handleClick()
    const url = sourceData.web_url
    if (url) {
      window.open(url, '_blank')
    }
  }

  return (
    <div
      className={clsx(styles['wrap'], className)}
      onClick={handleTextClick}
      ref={ref}
    >
      <span className={styles['tag']}>
        <span className={styles['tag-text']}>{sourceData.tag}</span>
      </span>
      <span className={styles['text']}>{sourceData.text}</span>
      <div className={styles['right']}>
        <span className={styles['ad-text']}>
          <span className={styles['ad-text-content']}>广告</span>
        </span>
        <i className="DCD_Icon icon_triangle_right" />
      </div>
    </div>
  )
}

export default AdTextLink
